import { render } from "./logincode_policy_modal.vue?vue&type=template&id=cbbe0b42"
import script from "./logincode_policy_modal.vue?vue&type=script&lang=js"
export * from "./logincode_policy_modal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/modal/logincode_policy_modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbbe0b42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbbe0b42', __exports__)) {
    api.reload('cbbe0b42', __exports__)
  }
  
  module.hot.accept("./logincode_policy_modal.vue?vue&type=template&id=cbbe0b42", () => {
    api.rerender('cbbe0b42', render)
  })

}


export default __exports__